import * as React from "react";
import * as MD from "@material-ui/core";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { Dispatch } from "redux";
import { connect } from "react-redux";

import { Login } from "../Pages/Login";
import { IApplicationState } from "../Store";
import {
  getAuthorizedMedias,
  loginSuccess,
  logout,
  saveExternalToken,
} from "../Store/User/Actions";
import { IUserState } from "../Store/User/Types";

import moment from "moment";
import MomentUtils from "@date-io/moment";
import { Dashboard } from "../Pages/Dashboard";
import { Statistics } from "../Pages/Statistics";
import { Player } from "../Pages/Player";
import { VideoPlayer } from "./VideoPlayer";
import { saveVideoPlayerParams } from "../Store/Player/Actions";
import { IPlayerState } from "../Store/Player/Types";
import { declarationsCSA } from "../Pages/DeclarationsCSA";
import { IElectionsState } from "../Store/Elections/Types";
import { isNullOrUndefined } from "../Utils/Various";
import { Authentication } from "./Authentication";
import { TypedStorage } from "../Utils/TypedStorage";

const styles = (theme: any) =>
  MD.createStyles({
    container: {
      userSelect: "none",
    },
  });

interface IPropsFromState {
  user: IUserState;
  player: IPlayerState;
  elections: IElectionsState;
  router: RouteComponentProps<{}>;
}

interface IPropsFromDispatch {
  logout: typeof logout;
  saveVideoPlayerParams: typeof saveVideoPlayerParams;
  loginSuccess: typeof loginSuccess;
  getAuthorizedMedias: typeof getAuthorizedMedias;
  saveExternalToken: typeof saveExternalToken;
}

type AllProps = MD.WithTheme &
  MD.WithStyles<typeof styles> &
  IPropsFromState &
  IPropsFromDispatch &
  RouteComponentProps<{}>;

export class RouterComponent extends React.Component<AllProps> {
  public render(): React.ReactNode {
    let nowDate = new Date();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get("token") as string;
    if (!isNullOrUndefined(token)) {
      this.props.saveExternalToken(token as string);
      return <Redirect to="/authentication" />;
    }
    const pathName = this.props.router.location.pathname;
    if (pathName.includes("/player/")) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const encodedParams = urlParams.get("k") as string;
      let decodedParams: string = atob(encodedParams);
      let params = decodedParams.split("&");
      let queryParams: any = [];
      for (var i = 0; i < params.length; i++) {
        var pair = params[i].split("=");
        if (pair[1] !== undefined) {
          if (pair[0] === "m" || pair[0] === "media_id") {
            queryParams[0] = pair[1];
          }
          if (pair[0] === "s" || pair[0] === "start_date") {
            queryParams[1] = pair[1];
          }
          if (pair[0] === "e" || pair[0] === "end_date") {
            queryParams[2] = pair[1];
          }
          if (pair[0] === "x" || pair[0] === "expires_at") {
            queryParams[3] = pair[1];
          }
          if (pair[0] === "f" || pair[0] === "fingerprint_id") {
            queryParams[4] = pair[1];
          }
        }
      }
      if (this.props.player.fingerprintID === undefined) {
        this.props.saveVideoPlayerParams(
          parseInt(queryParams[0]),
          parseInt(queryParams[1]),
          parseInt(queryParams[2]),
          parseInt(queryParams[3]),
          queryParams[4]
        );
      }
      return <Redirect to="/videoPlayer" />;
    }
    return (
      <MuiPickersUtilsProvider moment={moment} utils={MomentUtils}>
        <MD.CssBaseline />
        <MD.Grid
          container={true}
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{ height: "100%" }}
        >
          {this.props.user.expires > nowDate &&
          TypedStorage.get("userName", "") !== "" ? (
            <Switch>
              <Route
                exact={true}
                path={["/Talk", "/Talk/", "/"]}
                render={() => {
                  return <Redirect to={"/dashboard"} />;
                }}
              />
              <Route exact={true} path={"/dashboard"} component={Dashboard} />
              <Route exact={true} path={"/statistics"} component={Statistics} />
              <Route exact={true} path={"/player"} component={Player} />
              <Route
                exact={true}
                path={"/declarationsARCOM"}
                component={declarationsCSA}
              />
              <Route
                exact={true}
                path={"/videoPlayer"}
                component={VideoPlayer}
              />
              <Route
                exact={true}
                path="/logout"
                render={() => {
                  return <Redirect to="/" />;
                }}
              />
              <Route
                exact={true}
                path="/authentication"
                render={() => {
                  return <Redirect to="/" />;
                }}
              />
              <Route component={() => <div>Not Found</div>} />
            </Switch>
          ) : (
            <Switch>
              <Route
                exact={true}
                path="/authentication"
                component={Authentication}
              />
              <Route
                exact={true}
                path="/logout"
                render={() => {
                  return <Redirect to="/" />;
                }}
              />
              <Route component={Login} />
            </Switch>
          )}
        </MD.Grid>
      </MuiPickersUtilsProvider>
    );
  }
}

const mapStateToProps = (
  { user, player, elections }: IApplicationState,
  ownProps: RouteComponentProps<{}>
) => ({
  user,
  player,
  router: ownProps,
  elections,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  logout: () => dispatch(logout()),
  saveVideoPlayerParams: (
    media_id: number,
    start_date: number,
    end_date: number,
    expires_at: number,
    fingerprint_id: string
  ) =>
    dispatch(
      saveVideoPlayerParams(
        media_id,
        start_date,
        end_date,
        expires_at,
        fingerprint_id
      )
    ),
  loginSuccess: (
    username: string,
    token: string,
    expires: number,
    medias: any[],
    user_id: number,
    have_right_show_total: boolean
  ) =>
    dispatch(
      loginSuccess(
        username,
        token,
        expires,
        medias,
        user_id,
        have_right_show_total
      )
    ),
  getAuthorizedMedias: (token: string) => dispatch(getAuthorizedMedias(token)),
  saveExternalToken: (token: string) => dispatch(saveExternalToken(token)),
});

export const Router = MD.withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(RouterComponent)
) as any;
